// components/books/BookVideo.jsx
function BookVideo({
  videoId = 'y98_wolNDbE',
  title = 'A Personal Introduction',
  subtitle = 'Hear about the book directly from Loubna',
}) {
  return (
    <section
      style={{
        background: '#fcf3e5',
        margin: '0 20px',
        borderRadius: '1.5rem',
        padding: '6rem 3rem',
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <div
        style={{
          maxWidth: 900,
          margin: '0 auto',
          background: '#fff',
          borderRadius: '1.5rem',
          padding: '3rem 2.5rem',
          boxShadow: '0 8px 30px rgba(110, 79, 56, 0.08)',
        }}
      >
        <h2
          style={{
            fontWeight: 700,
            color: '#2d3436',
            fontSize: '2.2rem',
            margin: 0,
          }}
        >
          {title}
        </h2>
        <p
          style={{
            fontFamily: "'Poppins', sans-serif",
            color: '#6b6b6b',
            margin: '0.75rem 0 2rem',
          }}
        >
          {subtitle}
        </p>

        <div
          style={{
            position: 'relative',
            paddingBottom: '56.25%',
            height: 0,
            borderRadius: '1rem',
            overflow: 'hidden',
            border: '2px solid #8a6a96',
            boxShadow: '0 6px 20px rgba(138, 106, 150, 0.2)',
          }}
        >
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?rel=0`}
            title="Book introduction video"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 0,
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}

export default BookVideo;